module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens20-a2d5950401a2d27fab2aa6cb31ad7392.jpg";